import React, { createContext, useReducer } from 'react';

const getData = (key, value, store_key) => {
    var theData = '';
    if(localStorage.getItem(key)) {
        theData = localStorage.getItem(key);
    } else {
        theData = sessionStorage.getItem(key)
    }
    return theData;
}

const initialState = {
    theme: '',
    room: 'urb_2002',
    db: {},
    draft_order: [],
    prev_pick: '',
    current_pick: '',
    last_action: '',
    users: [],
    players: [],
    standings: [],
    me: getData('username') !== null ? getData('username') : '',
    myTeam: getData('teamId') !== null ? Number(getData('teamId')) : '',
    isAdmin: getData('admin') !== null && getData('admin') === 'true',
    isMyTurn: false,
}

const store = createContext(initialState);
const { Provider } = store;


// const updatePlayers = (data, obj) => {
//     var players = data;
//     var pid = obj.pid;
//     var team = obj.team;
//     var pick = obj.pick;

//     var newPlayer = players.find(x => x.pid === pid);
//     newPlayer.team = team;
//     newPlayer.pick = pick;

//     return newPlayer;
// }


const StateProvider = ({children}) => {
    const [state, dispatch] = useReducer((state, action) => {
        switch (action.type) {
            case 'SET_THEME' :
                return {...state, theme: action.value}
            case 'SET_ROOM' :
                return {...state, room: action.value}
            case 'SET_DB' :
                return {...state, db: action.value, draft_order: action.value.draft_order, users: action.value.users, players: action.value.players, last_action: action.value.last_action}
            case 'SET_DRAFT_ORDER' :
                return {...state, draft_order: action.value}
            case 'SET_PREV_PICK' :
                return {...state, prev_pick: action.value}
            case 'SET_CURRENT_PICK' :
                return {...state, current_pick: action.value}
            case 'SET_LAST_ACTION' :
                return {...state, last_action: action.value}
            case 'SET_USERS' :
                return {...state, users: action.value}
            case 'SET_PLAYERS' :
                return {...state, players: action.value}
            case 'SET_STANDINGS' :
                return {...state, standings: action.value}
            case 'SET_MY_TURN' :
                return {...state, isMyTurn: action.value}
            default :
                throw new Error();
        
        }
    }, initialState)

    return <Provider value = {{state,dispatch}} > {children} </Provider>
}

//
export {
    store,
    StateProvider
}